export default __webpack_public_path__ + "static/media/tasklist.65613b63.svg";